import { type DashboardTranslations } from './dashboard.translations.pl.ts';

export const dashboardTranslations: DashboardTranslations = {
  areas: {
    firstChoice: 'first choice',
    otherChoice: 'second or third choice',
    subtitle: 'Candidates who chose the area',
    title: 'Areas of interest',
  },
  close: 'Close',
  dataView: 'Data as a table',
  error: 'The statistics could not be loaded. Please try again in a moment.',
  feed: {
    empty: 'Nothing has happened in this period yet',
    events: {
      QUIZ_FINISHED: 'Quiz finished',
      QUIZ_STARTED: 'Quiz started',
      REGISTERED: 'New candidate',
    },
    subtitle: 'Latest events, without personal data',
    title: 'Live',
  },
  filter: {
    clear: 'Clear filter',
    region: '{{region}} · {{type}}',
    types: {
      INTERNSHIP: 'internship location',
      STUDY: 'university',
    },
  },
  funnel: {
    ofRegistered: '{{value}} of registered',
    stages: {
      EMAIL_VERIFIED: 'E-mail confirmed',
      PERSONAL_DATA: 'Personal data',
      QUIZ_FINISHED: 'Quiz finished',
      QUIZ_STARTED: 'Quiz started',
      RECOMMENDED: 'Recommended',
      REGISTERED: 'Registered',
    },
    stepConversion: '{{value}} of the previous stage',
    subtitle: 'How many candidates reach each stage',
    title: 'Recruitment funnel',
  },
  heatmap: {
    sessions: 'quiz sessions',
    subtitle: 'When candidates take the quiz (Polish time)',
    title: 'Activity during the week',
  },
  kpis: {
    averageQuizMinutes: 'Average quiz time',
    averageQuizPoints: 'Average quiz score',
    candidates: 'Candidates',
    conversion: 'Success rate',
    conversionHint: 'recommended among registered',
    fairCandidates: 'From job fairs',
    minutes: '{{value}} min',
    noPrevious: 'since the start of the recruitment',
    quizzesFinished: 'Quizzes finished',
    recommended: 'Recommended',
    vsPrevious: 'vs previous {{days}} days',
  },
  live: 'Live',
  map: {
    candidates: 'candidates',
    clickHint: 'Click a voivodeship to narrow the whole dashboard',
    layers: {
      INTERNSHIP: 'Internship location',
      STUDY: 'University',
    },
    outside: {
      INTERNSHIP: '{{count}} would do the internship anywhere in Poland',
      STUDY: '{{count}} study at a university that is not on the list',
    },
    ranking: 'Most candidates',
    share: 'share',
    subtitle: {
      INTERNSHIP: 'Voivodeships and cities where candidates want their internship',
      STUDY: 'Voivodeships where candidates study',
    },
    title: 'Where the candidates come from',
  },
  periods: {
    all: 'Whole recruitment',
    days30: '30 days',
    days7: '7 days',
    days90: '90 days',
    label: 'Period',
  },
  presentation: {
    start: 'Presentation mode',
    stop: 'End presentation',
  },
  profile: {
    gender: 'Gender',
    genders: {
      FEMALE: 'women',
      MALE: 'men',
      UNKNOWN: 'unknown',
    },
    languages: 'Language of the app',
    studentStatus: 'Status',
    subtitle: 'Who the candidates who gave their data are',
    title: 'Candidate profile',
    typeOfStudy: 'Type of studies',
    universities: 'Most chosen universities',
    yearOfStudy: 'Year of studies',
  },
  quiz: {
    candidates: 'candidates',
    notRecommended: 'not recommended',
    points: 'pts',
    recommended: 'recommended',
    scores: {
      AVERAGE: 'Average',
      GOOD: 'Good',
      LOW: 'Low',
      OUTSTANDING: 'Outstanding',
      VERY_GOOD: 'Very good',
    },
    subtitle: 'Points of finished quizzes and the score thresholds',
    title: 'Quiz results',
  },
  regions: {
    'PL-02': 'Lower Silesia',
    'PL-04': 'Kuyavia-Pomerania',
    'PL-06': 'Lublin',
    'PL-08': 'Lubusz',
    'PL-10': 'Lodz',
    'PL-12': 'Lesser Poland',
    'PL-14': 'Masovia',
    'PL-16': 'Opole',
    'PL-18': 'Subcarpathia',
    'PL-20': 'Podlaskie',
    'PL-22': 'Pomerania',
    'PL-24': 'Silesia',
    'PL-26': 'Swietokrzyskie',
    'PL-28': 'Warmia-Masuria',
    'PL-30': 'Greater Poland',
    'PL-32': 'West Pomerania',
  },
  saveImage: 'Save as image',
  skills: {
    assessments: 'assessments',
    languages: 'Languages: good or advanced',
    strongShare: 'rate themselves as good or advanced',
    subtitle: 'Share of candidates who rate themselves as good or advanced',
    title: 'Strongest skills',
  },
  subtitle: '{{from}} – {{to}}',
  timeline: {
    fairRegistrations: 'registrations at job fairs',
    quizzesFinished: 'quizzes finished',
    registrations: 'registrations',
    subtitle: 'Candidates day by day',
    title: 'Candidate inflow',
  },
  title: 'Recruitment in numbers',
  updatedAt: 'Updated {{time}}',
};
